import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, withStyles} from "@material-ui/core";

const styles = theme => ({
    buttonClose: {
        width: "50%",
        '&:hover': {
            color: theme.palette.buttonText.default,
            backgroundColor: theme.palette.secondary.main,
        }
    },
    buttonVerify: {
        width: "50%",
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    actions: {
        justifyContent: "center",
    },
});


const OverrideOtpModal = (props) => {
    const { classes, modal, translations, setOverrideModal, handleAuthenticatorModalOpen } = props;

    const handleClose = () => {
        setOverrideModal({open: false});
    }

    return (
        <Dialog open={modal.open}>
            <DialogTitle>
                {translations["override_two_factor_authentication"] || "Override two factor authentication"}
            </DialogTitle>
            <DialogContent>
                <Typography variant={"body1"}>{translations["sure_to_override_two_factor_authorization"] || "By clicking Yes you will override your current two factor authentication"}.</Typography>
            </DialogContent>
            <DialogActions className={classes.actions}>
                <Button onClick={handleClose} variant="contained" className={classes.buttonClose}>
                    {translations['no'] || 'No'}
                </Button>
                <Button onClick={()=>handleAuthenticatorModalOpen(modal.Type)} variant={"outlined"} className={classes.buttonVerify}>
                    {translations["yes"] || "Yes"}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default (withStyles(styles)(OverrideOtpModal));